const getPersonHtml = person => `
<div class="col-desk-4 col-tab-4 col-mob-12">
  <article class="card-item">
    <div class="card-item-content">
      <h3 class="cart-item-title">${person.name}</h3>
      <p class="card-item-subheading">${person.job_title}</p>
      ${
        person.phone_number
          ? `<dl>
        <dt>Phone:</dt>
        <dd>${person.phone_number}</dd>
      </dl>`
          : ``
      }
    </div>
  </article>
</div>
`;

const template = (header, people) => `
<section class="wp-block-deepsea-section section">
  <div class="section-wrapper">
    <h2>${header}</h2>
    <div class="wp-block-deepsea-columns">
      ${people.map(person => (person ? getPersonHtml(person) : '')).join('')}
    </div>
  </div>
</section>
`;

const displayResults = result => {
  let $template = '';

  if (!result) {
    document.querySelector('#bdm-results').innerHTML = $template;
    return;
  }

  if (result.ibdm || result.ebdm || result.bda || result.hybrid) {
    $template += template('Your contacts for sales enquiries are', [
      result.ibdm,
      result.ebdm,
      result.bda,
      result.hybrid,
    ]);
  }

  if (result.account_executive) {
    $template += template('Your contact regarding existing client enquiries', [
      result.account_executive,
    ]);
  }

  document.querySelector('#bdm-results').innerHTML = $template;
};

const displayError = error => `
<section class="wp-block-deepsea-section section">
  <div class="section-wrapper">
    <h2>${error}</h2>
  </div>
</section>
`;

const handleError = error => {
  document.querySelector('#bdm-results').innerHTML = displayError(
    typeof error === 'string' ? error : error.message,
  );
};

const handleValidation = error => {
  document.querySelector('.bdm-validation').innerHTML = !error ? '' : error;
};

const setMeta = (postcode, loading, error) => {
  const $meta = document.querySelector('#bdm-meta');

  if (!$meta) {
    return;
  }

  if (loading) {
    $meta.innerHTML = `<p class="deepsea-loader deepsea-loader--small deepsea-loader--white">
      <span class="deepsea-spinner">Loading...</span>
      Please wait
    </p>`;
    return;
  }

  if (error) {
    $meta.innerText = `No results found for "${postcode}"`;
    return;
  }

  $meta.innerText = `Displaying results for "${postcode}"`;
};

const fetchResults = postcode =>
  fetch(`${window.restUrl}deepsea/v1/bdm/find?code=${postcode}`).then(
    response =>
      // eslint-disable-next-line no-async-promise-executor
      new Promise(async (resolve, reject) => {
        const body = await response.json();

        // Fetch doesnt automatically throw an error
        // if the response isn't in the 200 range
        // so we check to confirm the status is >= 200 and < 400
        if (response.status >= 200 && response.status < 300) {
          resolve(body);
          return;
        }

        reject(body);
      }),
  );

const handleFormSubmission = async event => {
  event.preventDefault();
  const formData = new FormData(event.target);
  const postcode = formData.get('postcode');
  const regex = RegExp(
    '^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$',
  );

  if (!postcode) {
    return;
  }

  if (!regex.test(postcode)) {
    document.querySelector('#bdm-results').innerHTML = '';
    handleValidation('Please enter a valid postcode');
    return;
  }

  handleValidation();
  setMeta(postcode, true);
  displayResults();

  try {
    const result = await fetchResults(postcode);
    if (result) {
      setMeta(postcode);
      displayResults(result);
      return;
    }

    setMeta(postcode, false, true);
  } catch (e) {
    setMeta(postcode, false, true);
    handleError(e);
  }
};

const setupEvents = () => {
  const form = document.querySelector('#bdm-form');

  if (!form) {
    return;
  }

  form.addEventListener('submit', handleFormSubmission);
};

setupEvents();
